import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Domains allowed to host this application. Edit this array to change
// which hostnames are permitted. A hostname matches when it exactly
// equals an entry or is one of its subdomains.
const allowedHosts = ["badgelab.netlify.app", "badgeflow.app"];

function isHostAllowed(hostname) {
  if (!allowedHosts.length) return true;
  return allowedHosts.some(
    (domain) => hostname === domain || hostname.endsWith(`.${domain}`)
  );
}

const { protocol, hostname } = window.location;
const usingHttp = protocol === "http:" || protocol === "https:";

const authorisedToLaunch =
  process.env.NODE_ENV !== "production" ||
  (usingHttp && isHostAllowed(hostname));

if (authorisedToLaunch) {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  const container = document.getElementById("root");
  if (container) {
    document.body.innerHTML = "Something went wrong";
  }
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
